import * as React from "react";

const AvailabilityOutStock: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="M12 3.425c4.819 0 8.775 3.903 8.775 8.775A8.773 8.773 0 0 1 12 20.975 8.772 8.772 0 0 1 3.225 12.2 8.775 8.775 0 0 1 12 3.425zm0-1.3C6.436 2.125 1.925 6.638 1.925 12.2c0 5.566 4.511 10.075 10.075 10.075 5.564 0 10.075-4.51 10.075-10.075 0-5.562-4.511-10.075-10.075-10.075zM11.533 7a.488.488 0 0 0-.487.508l.284 6.825c.011.26.226.467.488.467h.364a.487.487 0 0 0 .487-.467l.285-6.825A.488.488 0 0 0 12.467 7h-.934zM12 15.613a1.138 1.138 0 1 0 0 2.275 1.138 1.138 0 0 0 0-2.275z"/>
        </svg>
    );
};

export default React.memo(AvailabilityOutStock);
